import types from '../types/index';

const registerCodeRequest = (payload) => ({
    type: types.code.REGISTER_CODE_REQUEST,
    payload,
});

const registerCodeErrors = (payload) => ({
    type: types.code.REGISTER_CODE_ERRORS,
    payload,
});

const resetPasswordCodeRequest = (payload) => ({
    type: types.code.RESET_PASSWORD_CODE_REQUEST,
    payload,
});

const ressetPasswordCodeErrors = (payload) => ({
    type: types.code.RESET_PASSWORD_CODE_ERRORS,
    payload,
});

const sendCodeAgain = (payload) => ({
    type: types.code.SEND_CODE_AGAIN,
    payload,
});

export default {
    registerCodeRequest,
    registerCodeErrors,
    resetPasswordCodeRequest,
    ressetPasswordCodeErrors,
    sendCodeAgain,
};